import React from 'react';
import styled from 'styled-components';
import { useCenterActiveTab } from '../../hooks/useTabBar';

// Contenido principal de la planilla (mesa y productores).
export const MainContent = styled.main`
  padding: 2rem;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    /* Abajo queda lugar para el botón flotante de "+ Agregar". */
    padding: 1rem 1rem 6rem;
  }
`;

const TabContainer = styled.div`
  margin-bottom: 2rem;
  border-bottom: 2px solid ${props => props.theme.colors.border};
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  /* En el celular la barra queda fija arriba al bajar por la planilla, y los
     bordes se esfuman para avisar que hay más pestañas de costado. */
  @media (max-width: 768px) {
    position: sticky;
    top: env(safe-area-inset-top);
    z-index: 900;
    margin: 0 -1rem 1rem;
    padding: 0 1rem;
    background-color: ${props => props.theme.colors.background};
    -webkit-mask-image: linear-gradient(to right, transparent 0, #000 1rem, #000 calc(100% - 2rem), transparent 100%);
    mask-image: linear-gradient(to right, transparent 0, #000 1rem, #000 calc(100% - 2rem), transparent 100%);
  }
`;

const TabButton = styled.button`
  font-family: ${props => props.theme.typography.titleFamily};
  font-size: 1rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: ${props => props.$active ? props.theme.colors.primary : props.theme.colors.textSecondary};
  position: relative;
  top: 2px;
  border-bottom: 2px solid ${props => props.$active ? props.theme.colors.primary : 'transparent'};
  transition: all 0.2s ease-in-out;
  white-space: nowrap;

  &:hover {
    color: ${props => props.theme.colors.primary};
  }

  @media (max-width: 768px) {
    padding: 0.85rem 1rem;
    font-size: 0.95rem;
  }
`;

/**
 * Barra de pestañas principal. `tabs` es una lista de { key, label }.
 * En el celular la pestaña activa se centra sola y la barra queda fija arriba.
 */
export const MainTabBar = ({ tabs, activeTab, onChange }) => {
  const tabBarRef = useCenterActiveTab(activeTab);
  return (
    <TabContainer ref={tabBarRef} role="tablist">
      {tabs.map(({ key, label }) => (
        <TabButton
          key={key}
          type="button"
          role="tab"
          aria-selected={activeTab === key}
          $active={activeTab === key}
          onClick={() => onChange(key)}
        >
          {label}
        </TabButton>
      ))}
    </TabContainer>
  );
};
